// this file might not be used, as although it is present in Routes.js, nothing uses that URL
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchManifests,
  // resetFacilities
} from "../../../redux/actions/manifestActions";
import { fetchPreviousHistory } from "../../../redux/actions/historyAction";
import SearchFields from "./SearchFields";
import Sorting from "./Sorting";
import SearchItem from "./SearchItem";
import Pagination from "./Pagination";
import SearchItemPlaceholder from "../../shared/placeholders/SearchItemPlaceholder";
import urlParameterHelper from "../../../utilities/urlParameters";

class SearchManifests extends Component {
  constructor(props) {
    super(props);

    const params = urlParameterHelper.parse(this.props.location.search);
    let keyword = params.keyword == undefined ? "" : params.keyword;

    this.state = {
      keyword: keyword,
      isFetching: this.props.search.isFetching,
      options: this.props.search.options,
      filters: this.props.search.filters,
      queryString: "",
      showMap: true,
    };
  }

  componentDidMount() {
    let query = { ...this.state.filters, keyword: this.state.keyword };
    const queryString = urlParameterHelper.stringify(query);
    if (this.props.previousPage === "/landing") {
      this.props.history.push(`/search?${queryString}`);
      this.props.fetchManifests(
        `?${queryString}`,
        this.state.options,
        this.props.search.searchResults
      );
      this.props.fetchPreviousHistory("/search");
    }
  }

  componentDidUpdate() {
    //console.log(this.props.previousPage);
  }

  handleOnKeywordChange = (e) => {
    this.setState(
      {
        keyword: e.target.value,
      },
      () => {
        // this.resetFilters();
        this.setState({
          ...this.state,
          filters: {
            ...this.state.filters,
            page: 1,
          },
        });
      }
    );
  };

  handleOnSubmit = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    const params = urlParameterHelper.parse(this.props.location.search);
    let keyword = params.keyword == undefined ? "" : params.keyword;

    this.setState(
      {
        ...this.state,
        isFetching: true,
        queryString: urlParameterHelper.stringify(this.state.filters),
      },
      () => {
        const query = urlParameterHelper.parse(this.state.queryString);
        let newQ = { ...query, keyword: this.state.keyword };
        const newQuery = `?${urlParameterHelper.stringify(newQ)}`;

        this.props.history.push(`/search-manifests${newQuery}`);
        this.props.fetchManifests(
          newQuery,
          this.state.options,
          this.props.search.searchResults
        );
      }
    );
  };

  onSearchOptionsChange = (option) => {
    var key = Object.keys(option)[0];
    var value = option[key];

    this.setState(
      {
        ...this.state,
        options: {
          ...this.state.options,
          [key]: value,
        },
      },
      () => {
        this.props.history.push(
          `/search?keyword=${this.state.keyword}&${urlParameterHelper.stringify(
            this.state.options
          )}`
        );
        this.props.fetchFacilities(
          this.state.keyword,
          this.state.options,
          this.props.search.searchResults
        );
      }
    );
  };

  onPageChange = (e, event) => {
    this.setState(
      {
        ...this.state,
        filters: {
          ...this.state.filters,
          page: e.page,
        },
      },
      () => {
        this.setState(
          {
            ...this.state,
            queryString: urlParameterHelper.stringify(this.state.filters),
          },
          () => {
            const query = urlParameterHelper.parse(this.state.queryString);
            let newQ = { ...query, keyword: this.state.keyword };
            const newQuery = `?${urlParameterHelper.stringify(newQ)}`;

            this.props.history.push(`/search${newQuery}`);
            this.props.fetchFacilities(
              newQuery,
              this.state.options,
              this.props.search.searchResults
            );
          }
        );
      }
    );
  };

  onPageSizeChange = (e) => {
    this.setState(
      {
        ...this.state,
        filters: {
          ...this.state.filters,
          page: 1,
          [e.target.name]: e.target.value,
        },
      },
      () => this.handleOnSubmit(e)
    );
  };

  onFilterChange = (e) => {
    if (e.target.name === "type" && e.target.value === "epa_id") {
      this.resetFaciltyFilters();
      return;
    }
    this.setState({
      ...this.state,
      filters: {
        ...this.state.filters,
        page: 1,
        [e.target.name]: e.target.value,
      },
    });
  };

  resetFilters = () => {
    this.setState({
      ...this.state,
      keyword: "",
      filters: {
        epa_id: false,
        facility: false,
        street: "",
        city: "",
        active: "both",
        county: "",
        zipCode: "",
        sort: "EPA_ID",
        sortBy: "ASC",
        type: "all",
        page: 1,
        pageSize: 10,
      },
    });
  };

  resetFaciltyFilters = (e) => {
    this.setState({
      ...this.state,
      filters: {
        ...this.state.filters,
        epa_id: false,
        facility: false,
        street: "",
        city: "",
        active: "both",
        county: "",
        zipCode: "",
        sort: "EPA_ID",
        sortBy: "ASC",
        type: "epa_id",
        page: 1,
        pageSize: 10,
      },
    });
  };

  onSortingChange = (e) => {
    this.setState(
      {
        ...this.state,
        filters: {
          ...this.state.filters,
          page: 1,
          [e.target.name]: e.target.value,
        },
      },
      () => this.handleOnSubmit(e)
    );
  };

  onUpdateSearch = () => {
    let arr = this.state.options;
    let n = this.state.filters;
    arr = Object.assign(n, arr);
    this.props.history.push(
      `/search?keyword=${this.state.keyword}&${urlParameterHelper.stringify(arr)}`
    );
    this.props.fetchFacilities(this.state.keyword, arr);
  };

  // appears to be unused
  resetFilterState = (keyword) => {
    this.setState(
      {
        ...this.state,
        keyword: keyword,
        filters: {
          epa_id: false,
          facility: false,
          street: "",
          city: "",
          state: "CA",
          active: "both",
          county: "",
          zipCode: "",
          sort: "EPA_ID",
          sortBy: "ASC",
          type: "all",
          page: 1,
          pageSize: 10,
        },
        queryString: urlParameterHelper.stringify(this.state.filters),
      },
      () => {
        let query = { ...this.state.filters, keyword: this.state.keyword };
        const queryString = urlParameterHelper.stringify(query);
        
        this.props.history.push(`/?${queryString}`);
        this.props.fetchFacilities(`?${queryString}`, this.state.options);
      }
    );
  };

  getPageSize() {
    let arr = [];

    for (let i = 0; i < this.props.search.filters.pageSize; i++) {
      arr.push(i);
    }
    return arr;
  }

  render() {
    if (!this.props.search.searchResults) {
      // return <LoadingCircles />
      return <SearchItemPlaceholder />;
    }

    let results = this.props.search.searchResults.map((result) => (
      <SearchItem key={result.EPA_ID} result={result} />
    ));

    let { options, keyword, filters } = this.state;

    let { search, isFetching } = this.props;

    const itemsPerPage = [
      { name: "10", value: 10 },
      { name: "20", value: 20 },
      { name: "50", value: 50 },
      { name: "100", value: 100 },
    ];

    const itemPlaceholder = this.getPageSize().map((page) => (
      <SearchItemPlaceholder key={page} />
    ));

    return (
      <div className="" style={{ height: "100%" }}>
        {/* <SectionSection title={"Search for Handlers"} type={"standout"} /> */}
        <SearchFields
          handleOnSubmit={this.handleOnSubmit}
          keyword={keyword}
          handleOnKeywordChange={this.handleOnKeywordChange}
          onFilterChange={this.onFilterChange}
          filters={filters}
          resetFilters={this.resetFilters}
          onUpdateSearch={this.onUpdateSearch}
        />
        <div style={{ backgroundColor: "#F5F5F5" }}>
          <div className="searchcontainer">
            <div
              className="results-container"
              style={{ padding: "0 15px", width: "40%", float: "left" }}
            >
              <div>
                <Sorting
                  onPageSizeChange={this.onPageSizeChange}
                  onSortingChange={this.onSortingChange}
                  onSearchOptionsChange={this.onSearchOptionsChange}
                  isFetching={search.isFetching}
                  filters={this.state.filters}
                  results={search.options}
                />

                {search.isFetching ? (
                  <div>{itemPlaceholder}</div>
                ) : (
                  <div>{results}</div>
                )}

                {search.isFetching ? (
                  <div style={{ width: "100%" }}>
                    <div
                      className="animated-background"
                      style={{
                        height: "36px",
                        width: "500px",
                        margin: "0 auto",
                      }}
                    />
                    <br />
                    <div
                      className="animated-background"
                      style={{
                        height: "22px",
                        width: "180px",
                        margin: "0 auto",
                      }}
                    />
                    <div style={{ backgroundColor: "#F5F5F5" }}>
                      <div className="searchcontainer">
                        <div
                          className="results-container"
                          style={{
                            padding: "15px 15px",
                            width: "40%",
                            float: "left",
                          }}
                        >
                          <div>
                            <Sorting
                              onPageSizeChange={this.onPageSizeChange}
                              onSortingChange={this.onSortingChange}
                              onSearchOptionsChange={this.onSearchOptionsChange}
                              isFetching={search.isFetching}
                              filters={this.state.filters}
                              results={search.options}
                            />

                            {search.isFetching ? (
                              <div>{itemPlaceholder}</div>
                            ) : (
                              <div>{results}</div>
                            )}

                            {search.isFetching ? (
                              <div style={{ width: "100%" }}>
                                <div
                                  className="animated-background"
                                  style={{
                                    height: "36px",
                                    width: "500px",
                                    margin: "0 auto",
                                  }}
                                ></div>
                                <br />
                                <div
                                  className="animated-background"
                                  style={{
                                    height: "22px",
                                    width: "180px",
                                    margin: "0 auto",
                                  }}
                                ></div>
                              </div>
                            ) : this.props.search.searchResults.length > 0 ? (
                              <Pagination
                                onPageChange={this.onPageChange}
                                options={search.options}
                              />
                            ) : null}
                          </div>
                        </div>
                        {this.state.showMap && (
                          <div
                            className="map-container"
                            style={{ width: "60%", float: "left" }}
                          ></div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : this.props.search.searchResults.length > 0 ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    options={search.options}
                  />
                ) : (
                  <div
                    className="m-t-md"
                    style={{ fontStyle: "italic", textAlign: "center" }}
                  >
                    Search for Handlers using the search bar above.
                  </div>
                )}
              </div>
            </div>
            {this.state.showMap && (
              <div
                className="half map-container"
                style={{ width: "60%", float: "left" }}
              >
                <div style={{ width: "100%", height: "100%" }}></div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Search.propTypes = {
//     fetchFacilities: PropTypes.func.isRequired,
//     resetFacilities: PropTypes.func.isRequired,
//     search: PropTypes.array.isRequired
// }

const mapStateToProps = (state) => ({
  search: state.manifest,
  previousPage: state.history.previousPage,
});

export default connect(mapStateToProps, {
  fetchManifests,
  // resetFacilities,
  fetchPreviousHistory,
})(SearchManifests);
